import type { RoutingSmartSettingsResponse } from '@nadoutong/contracts';
import { useT } from '../../i18n/index.ts';
import { RadioGroup } from '../../ui/index.ts';

/**
 * SKU-level manual | smart switch. Lives on the left of the pool panel
 * header. A SKU that is not smart keeps the rest of the panel unchanged.
 */
export function TenantRoutingSmartModeSwitch({
  skuId,
  settings,
  saving,
  locked,
  onChange,
}: {
  readonly skuId: string;
  readonly settings: RoutingSmartSettingsResponse | undefined;
  readonly saving: boolean;
  /** Pending or failed settings GET — the radios must not PUT. */
  readonly locked: boolean;
  readonly onChange: (enabled: boolean) => void;
}): JSX.Element {
  const t = useT();
  const enabled = settings?.enabled === true;
  const disabled = saving || locked;
  return (
    <span
      className="inline-flex shrink-0 items-center gap-2"
      data-testid={`tenant-routing-smart-mode-${skuId}`}
    >
      <span className="text-label text-paper-low">{t('tenant_routing.smart.mode')}</span>
      <RadioGroup
        orientation="horizontal"
        value={enabled ? 'smart' : 'manual'}
        onValueChange={(value) => {
          if (disabled) return;
          if (value === 'smart') onChange(true);
          if (value === 'manual') onChange(false);
        }}
        ariaLabel={t('tenant_routing.smart.mode')}
        className="gap-x-3 text-label"
        options={[
          {
            value: 'manual',
            label: t('tenant_routing.smart.mode.manual'),
            disabled,
          },
          {
            value: 'smart',
            label: t('tenant_routing.smart.mode.smart'),
            disabled,
          },
        ]}
      />
    </span>
  );
}
